export default function extractRedirectSuccessFromUrl(locationSearch: string): string | null {
    const stringS = '?redirectSuccess='
    return locationSearch.slice(locationSearch.indexOf(stringS) + stringS.length, locationSearch.length) || null
}
